"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
exports.notifications = notifications;
var actions = _interopRequireWildcard(require("../actions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const initialState = exports.initialState = {
  entities: [],
  nextToken: null,
  error: null,
  isWidgetExpanded: false
};
function notifications(state = initialState, action) {
  switch (action.type) {
    case actions.WS_NEW_NOTIFICATION:
      {
        const foundEntity = state.entities.find(item => item.ID === action.payload.ID);
        if (foundEntity) {
          return {
            ...state,
            entities: state.entities.map(item => {
              return item.ID === action.payload.ID ? {
                ...action.payload
              } : item;
            })
          };
        }
        return {
          ...state,
          entities: [action.payload].concat(state.entities)
        };
      }
    case actions.GET_NOTIFICATIONS_PENDING:
      return {
        ...state,
        error: null
      };
    case actions.GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        entities: [...state.entities, ...action.payload.notifications],
        nextToken: action.payload.nextPageToken
      };
    case actions.GET_NOTIFICATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        entities: initialState.entities,
        nextToken: initialState.nextToken
      };
    case actions.UPDATE_NOTIFICATION_PENDING:
      return {
        ...state,
        error: null
      };
    case actions.UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        error: null,
        entities: state.entities.map(item => {
          return item.ID === action.payload ? {
            ...item,
            isRead: true
          } : item;
        })
      };
    case actions.UPDATE_NOTIFICATION_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case actions.READ_ALL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        error: null,
        entities: state.entities.map(item => ({
          ...item,
          isRead: true
        }))
      };
    case actions.SHOW_NOTIFICATION_WIDGET:
      return {
        ...state,
        isWidgetExpanded: true
      };
    case actions.HIDE_NOTIFICATION_WIDGET:
      return {
        ...state,
        isWidgetExpanded: false
      };
    default:
      return state;
  }
}